import React from 'react';
import Grid from './Grid.jsx';

class Contas extends React.Component {

    constructor() {

        super();

        this.state = {
            gridHeader: [ "Centro" ],
            centros: []
        };

    }

    componentDidMount() {

        if (localStorage.roleContas === "nenhuma") {
            window.location.href = "/home";
        }

        fetch("/api/centro/grid2", {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centros: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="contas-title">Contas</h1><br />
                <p id="contas-txt">
                    Escolha um centro para verificar as suas contas.
                </p><br />
                <Grid key={ this.state.centros }
                    header={ this.state.gridHeader }
                    data={ this.state.centros }
                    pageSize={ 10 }
                    gridWidth={ "600px" }
                    linkTo={ "/contascentro" } />
            </div>
        );
    }

}

export default Contas;

